export default {
  state: {
    customerCategories: [],
    loading: false,
  },
  getters: {
    customerCategories: state => state.customerCategories,
    loading: state => state.loading,
  },
  mutations: {
    setCustomerCategories(state, customerCategories) {
      state.customerCategories = customerCategories;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const customerCategories = await axios.get('api/customer-categories');
        commit('setCustomerCategories', customerCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },
  },
};
